import css_s31w63snbpg from './css/VjsSettings.css';
import Div from "./Div.js";
import eventOptions from '../Functions/eventOptions.js';

const css = css_s31w63snbpg;

export default class VjsSettings extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		let self = this;

		this.settingsElement = new Div(this).element;
		this.settingsElement.className = 'settings';

		let q = '225';

		this.settings =
		{
			Quality:
			{
				values: ['placeholder'],
				get value()
				{
					return q;
				},
				set value(value)
				{
					q = value;

					const qInt = parseInt(q);

					self.vjsHls.playlists.master.playlists.forEach
					(
						v =>
						{
							v.disabled = v.attributes.RESOLUTION.height > qInt;
						}
					);
					self.vjsHls.masterPlaylistController_.goalBufferLength = function(){return 10;};
					self.vjsHls.masterPlaylistController_.smoothQualityChange_();
				}
			},
			// Loop:
			// {
			// 	values: ['Clip','Playlist','Off'],
			// 	value: 'Playlist',
			// },
			// Float:
			// {
			// 	value: false,
			// },
		};

		this.selected = null;

		// intercept videojs's bizzare touch system that replaces native click events which work JUST FINE on all modern browsers
		this.settingsElement.addEventListener
		(
			'touchstart',
			e =>
			{
				e.stopImmediatePropagation();
			},
			true
		);

		this.settingsElement.addEventListener
		(
			'click',
			e =>
			{
				if(this.selected && e.target === this.settingsElement)
				{
					this.selected = null;
					this.render();
				}
			}
		);

		this.render();

	}

	get cssText()
	{
		return css;
	}

	onLoadedMetadata(vjs)
	{
		// if there is no hls plugin loaded, then there is no setting
		// todo: if another setting gets added, modify this check
		if(vjs.tech_.hls)
		{
			const representations = vjs.tech_.hls.representations().sort((a,b) => a.height - b.height);
			this.vjsHls = vjs.tech_.hls;
			const values = this.settings.Quality.values = representations.map(v => v.height + 'p');
			let i, value = parseInt(this.settings.Quality.value);
			for(i = 0; i < values.length && value > parseInt(values[i]); ++i){}
			this.settings.Quality.value = values[i] || values[i-1];

			this.render();

			return true;
		}
		else
		{
			return false;
		}
	}

	renderRoot()
	{
		this.selected = null;
		this.render();
	}

	render()
	{
		this.settingsElement.setAttribute('data-name',this.selected && this.selected.replace(/(.)([A-Z])/,'$1 $2') || 'Settings');

		const fragment = document.createDocumentFragment();

		this.settingsElement.classList.toggle('active',this.selected);

		if(!this.selected)
		{
			Object.keys(this.settings).forEach
			(
				name =>
				{
					const value = this.settings[name].value;
					const divTag = document.createElement('div');
					divTag.setAttribute('data-name',name.replace(/(.)([A-Z])/,'$1 $2'));
					switch(typeof value)
					{
						case 'string':
						{
							divTag.textContent = value + ' ▶︎';
							divTag.addEventListener
							(
								'click',
								() =>
								{
									this.selected = name;
									this.render();
								}
							);
						}
							break;
						case 'boolean':
						{
							divTag.classList.add(value ? 'true' : 'false');
							divTag.addEventListener
							(
								'click',
								() =>
								{
									this.settings[name].value = !this.settings[name].value;
									this.render();
								}
							);
						}
							break;
					}
					fragment.appendChild(divTag);
				}
			);
		}
		else
		{
			const setting = this.settings[this.selected];
			const values = typeof(setting.values) === 'function' ? setting.values() : setting.values;
			const value = setting.value;

			values.forEach
			(
				name =>
				{
					const divTag = document.createElement('div');
					divTag.textContent = name;
					if(name === value)
					{
						divTag.classList.add('true');
					}
					else
					{
						divTag.addEventListener
						(
							'click',
							() =>
							{
								setting.value = name;
								this.render();
							}
						)
					}

					fragment.appendChild(divTag);
				}
			);
		}

		this.settingsElement.innerHTML = '';
		this.settingsElement.appendChild(fragment);
	}
}
